import { render, staticRenderFns } from "./ProductAppointments.vue?vue&type=template&id=a925455a"
import script from "./ProductAppointments.vue?vue&type=script&lang=js"
export * from "./ProductAppointments.vue?vue&type=script&lang=js"
import style0 from "./ProductAppointments.vue?vue&type=style&index=0&id=a925455a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports